export default __webpack_public_path__ + "static/media/pl.6fe5fb35.svg";